export const MAX_APPROVAL_TITLE_LENGTH = 70;